export default "__VITE_ASSET__BUC6qiu7__"